<template>
  <div class="event-modal-catalog-rubrics">
    <div class="event-modal-catalog-rubrics__section">
      <h2 class="event-modal-catalog-rubrics__title">
        {{ $t("event.catalog.modal.rubricator.rubricsTitle") }}
        <span>
          ({{ $t("event.catalog.modal.rubricator.rubricsFreeNote") }}
          {{ freeRubricsCount }}
          {{
            freeRubricsCount
              | pluralize(
                $t("event.catalog.modal.rubricator.rubricsFreeNotePluralize")
              )
          }})
        </span>
      </h2>

      <PrimaryButton
        @click="$modal.show('event-modal-catalog-rubrics')"
        v-if="hasAccessToWrite && !selectedRubricsId.length"
      >
        {{ $t("event.catalog.modal.rubricator.chooseRubricsBtn") }}
      </PrimaryButton>

      <div
        class="event-modal-catalog-rubrics__for-all"
        v-if="selectedRubricsId.length"
      >
        <h3 class="event-modal-catalog-rubrics__for-all-title">
          {{ $t("event.catalog.modal.rubricator.forAllTitle") }}
        </h3>

        <div class="event-modal-catalog-rubrics__checkboxes">
          <div
            v-for="service in rubricServicesForAllCheckboxes"
            :key="service.id"
            class="event-modal-catalog-rubrics__checkboxes-item"
          >
            <Checkbox
              :disabled="!hasAccessToWrite"
              :value="service.isEnabled"
              @click="
                serviceCheckboxHandler(service, !service.isEnabled, $event)
              "
            >
              <div class="event-modal-catalog-rubrics__for-all-checkbox">
                {{ service.title }}

                <EventModalCatalogExample
                  class="_center"
                  :label="false"
                  :images="service.images"
                />
              </div>
            </Checkbox>
          </div>
        </div>
      </div>
    </div>

    <div
      class="event-modal-catalog-rubrics__section"
      v-if="rubricsWithServices.length"
    >
      <section
        class="event-modal-catalog-rubrics__rubric"
        v-for="rubric in rubrics"
        :key="rubric.id"
      >
        <header class="event-modal-catalog-rubrics__rubric-header">
          {{ rubric.title }}

          <span
            class="event-modal-catalog-rubrics__rubric-header-price"
            :class="{ _highlight: rubric.totalPrice > 0 }"
            v-html="`${rubric.totalPrice} ${currencySymbol}`"
          >
          </span>

          <button
            v-if="hasAccessToWrite"
            class="button-clean event-modal-catalog-rubrics__rubric-header-delete"
            @click="deleteRubric(rubric.id)"
          >
            <icon name="delete" width="16" height="16" />
          </button>
        </header>

        <div class="event-modal-catalog-rubrics__rubric-content">
          <div class="event-modal-catalog-rubrics__checkboxes">
            <div
              class="event-modal-catalog-rubrics__checkboxes-item"
              v-for="service in rubric.services"
              :key="service.id"
            >
              <Checkbox
                :disabled="!hasAccessToWrite"
                :value="rubricServiceValue(rubric, service)"
                @input="rubricServiceSetValue(rubric, service, $event)"
              >
                {{ service.title }}

                <p class="event-modal-catalog-rubrics__checkboxes-item-desc">
                  {{ service.description }}
                </p>

                <div
                  class="event-modal-catalog-rubrics__checkboxes-item-price"
                  :class="{
                    _highlight: rubricServiceValue(rubric, service)
                  }"
                >
                  <template v-if="service.errorPrice">
                    <ErrorPriceCatalog />
                  </template>
                  <span
                    v-else-if="service.oldPrice"
                    class="event-modal-catalog-rubrics__checkboxes-item-oldprice"
                  >
                    {{ service.oldPrice }} {{ currencySymbol }}
                  </span>
                  <template v-else>
                    {{ service.price }} {{ currencySymbol }}
                  </template>
                </div>
              </Checkbox>
              <div
                class="event-modal-catalog-rubrics__checkboxes-item-address"
                v-if="
                  rubricServiceValue(rubric, service) &&
                    service.isFullInfoService
                "
              >
                <InputLabel>
                  <div
                    v-for="item in rubricsAddresses.filter(
                      rubricAddress => rubricAddress.rubricId === rubric.id
                    )"
                    :key="item.id"
                    style="display: flex;"
                  >
                    <input
                      placeholder="111111 Москва, Московский пр., 12"
                      v-model="item.address"
                      class="input event-modal-catalog-rubrics__checkboxes-address"
                      :disabled="!hasAccessToWrite"
                      @input="item.address = item.address.replace(regex, '')"
                    />

                    <button
                      class="button-clean"
                      style="margin-left: 10px; margin-top: -16px"
                      @click="deleteAddress(item.id)"
                    >
                      <icon name="delete" width="16" height="16" />
                    </button>
                  </div>
                </InputLabel>

                <LinkIcon
                  @click="addAddress('', rubric.id)"
                  icon="add"
                  grey
                  bold
                  v-if="hasAccessToWrite"
                  class="event-catalog-participant__add-address-btn"
                >
                  {{
                    $t(
                      "event.catalog.modal.alphabetList.extraCompanyAddressForRubric"
                    )
                  }}
                  <template v-if="additionalRubricatorAddressPrice.errorPrice">
                    (<ErrorPriceCatalog />)
                  </template>
                  <template v-else>
                    ({{ additionalRubricatorAddressPrice.price }}
                    {{ currencySymbol }})
                  </template>
                </LinkIcon>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div
      class="event-modal-catalog-rubrics__section"
      v-if="hasAccessToWrite && selectedRubricsId.length"
    >
      <LinkIcon
        icon="add"
        :bold="true"
        @click="$modal.show('event-modal-catalog-rubrics')"
      >
        {{ $t("event.catalog.modal.rubricator.addRubricBtn") }}
      </LinkIcon>
    </div>

    <div
      class="event-modal-catalog-rubrics__section"
      v-if="rubricsPackages.length"
    >
      <h2 class="event-modal-catalog-rubrics__title">
        {{ $t("event.catalog.modal.rubricator.packagePlacement") }}

        <span class="event-modal-catalog-rubrics__title-primary">
          ({{ $t("event.catalog.modal.rubricator.packagePlacementPrimary") }})
        </span>
      </h2>

      <div class="event-modal-catalog-rubrics__packages">
        <div
          v-for="pkg in rubricsPackages"
          :key="pkg.id"
          class="event-modal-catalog-rubrics__packages-item"
          :class="{ _active: selectedPackagesId.indexOf(pkg.id) > -1 }"
        >
          <icon name="ok" />

          <div class="event-modal-catalog-rubrics__packages-item-top">
            <h3 class="event-modal-catalog-rubrics__packages-item-title">
              <span>
                {{ pkg.title }}

                <span
                  v-if="countPack[pkg.id] > 1"
                  class="event-modal-catalog-rubrics__packages-item-count"
                >
                  х{{ countPack[pkg.id] }}
                </span>
              </span>
              <EventModalCatalogExample
                :images="pkg.images"
                data-event-modal-catalog-example
              >
                <template #label>
                  Пример
                </template>
              </EventModalCatalogExample>
            </h3>

            <p
              v-if="pkg.subtitle"
              class="event-modal-catalog-rubrics__packages-item-text"
            >
              {{ pkg.subtitle }}
            </p>
          </div>

          <p class="event-modal-catalog-rubrics__packages-item-price">
            <span
              v-if="pkg.errorPrice"
              class="event-modal-catalog-rubrics__packages-item-mainprice"
            >
              <ErrorPriceCatalog />
            </span>
            <span
              v-else
              v-html="
                `${getPriceForPkg(
                  pkg.price,
                  countPack[pkg.id]
                )}&nbsp;${currencySymbol}`
              "
              class="event-modal-catalog-rubrics__packages-item-mainprice"
            >
            </span>

            <span v-if="countPack[pkg.id] > 1 && !pkg.errorPrice">
              ({{
                countSelectedPakage(
                  countPack[pkg.id],
                  `${pkg.price} ${currencySymbol}`
                )
              }})
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import ErrorPriceCatalog from "@/components/Modal/Catalog/ErrorPriceCatalog.vue";
import {
  PrimaryButton,
  LinkIcon,
  Checkbox,
  InputLabel
} from "@v2/shared/ui/components";
import EventModalCatalogExample from "./EventModalCatalogExample.vue";
import shortid from "shortid";
import { asianArabicRegex } from "@/helpers/constants/regex";

export default {
  name: "EventModalCatalogRubricsForm",

  components: {
    InputLabel,
    ErrorPriceCatalog,
    PrimaryButton,
    EventModalCatalogExample,
    Checkbox,
    LinkIcon
  },

  data: () => ({
    regex: asianArabicRegex
  }),

  computed: {
    ...mapState("event", ["event"]),
    ...mapState("eventCatalog", [
      "selectedRubricsId",
      "selectedServicesForRubrics",
      "selectedPackagesId",
      "step",
      "rubricsAddresses"
    ]),

    ...mapGetters("eventCatalog", [
      "freeRubricsCount",
      "additionalRubricPrice",
      "rubricServices",
      "rubricsWithServices",
      "rubricsPackages",
      "currencySymbol",
      "getOrderDataFromCatalog",
      "additionalRubricatorAddressPrice"
    ]),

    ...mapGetters("event", ["hasAccessToWrite", "eventId"]),

    rubrics() {
      return this.rubricsWithServices;
    },

    rubricServicesForAllCheckboxes() {
      // получает сервисы для секции "Для всех выбранных рубрик"

      /**
       * @var service данные о сервисе
       */
      return [...this.rubricServices].map(service => {
        let serviceEnabledCount = 0;

        /**
         * @var rubric данные о рубрике (выбранные)
         */
        this.rubrics.forEach(rubric => {
          if (this.rubricServiceValue(rubric, service)) {
            serviceEnabledCount++;
          }
        });

        service.isEnabled = serviceEnabledCount === this.rubrics.length;

        return service;
      });
    },

    rubricsPackagesSortDescDiscount() {
      return this.getRubricsPackagesSortDescDiscount();
    },

    countPack() {
      if (this.selectedPackagesId && this.selectedPackagesId.length) {
        return this.selectedPackagesId.reduce((acc, rec) => {
          return typeof acc[rec] !== "undefined"
            ? { ...acc, [rec]: acc[rec] + 1 }
            : { ...acc, [rec]: 1 };
        }, {});
      } else {
        return {};
      }
    }
  },

  watch: {
    selectedServicesForRubrics() {
      this.setActiveRubricsPackages();
    },
    rubricsPackagesSortDescDiscount() {
      this.setActiveRubricsPackages();
    }
  },

  methods: {
    ...mapActions("eventCatalog", [
      "updateServiceForRubric",
      "deleteRubric",
      "updateRubricsAddresses"
    ]),
    ...mapMutations("event", ["UPDATE_CATALOG_STATUS"]),

    rubricServiceValue(rubric, service) {
      if (!this.selectedServicesForRubrics[rubric.id]) {
        return null;
      }

      return (
        this.selectedServicesForRubrics[rubric.id].indexOf(service.id) > -1
      );
    },

    rubricServiceSetValue(rubric, service, value) {
      this.updateServiceForRubric({
        rubricId: rubric.id,
        serviceId: service.id,
        relatedServiceId: service.relatedServiceId,
        value
      });

      if (!value && service.isFullInfoService) {
        const currentRubricsAddress = this.rubricsAddresses.filter(
          address => address.rubricId !== rubric.id
        );

        this.updateRubricsAddresses(currentRubricsAddress);
      }
    },

    serviceCheckboxHandler(service, value, $event) {
      if ($event.srcElement.tagName !== "INPUT") {
        return;
      }

      this.rubrics.forEach(rubric => {
        this.rubricServiceSetValue(rubric, service, value);
      });
    },

    addAddress(address = "", rubricId = null) {
      this.rubricsAddresses.push({
        id: shortid.generate(),
        address,
        rubricId
      });
    },

    deleteAddress(addressId) {
      const index = this.rubricsAddresses.findIndex(x => x.id === addressId);

      if (index === -1) {
        return;
      }

      this.rubricsAddresses.splice(index, 1);
    },

    getRubricsPackagesSortDescDiscount() {
      if (!this.rubricsPackages || !this.rubricsPackages.length) return [];

      let sortRubricsPackages = [...this.rubricsPackages];

      return sortRubricsPackages.sort((a, b) => {
        let allPricePackageA = 0;
        let allPricePackageB = 0;

        a.servicesPriceList.forEach(el => (allPricePackageA += el.price));
        b.servicesPriceList.forEach(el => (allPricePackageB += el.price));

        if (allPricePackageA - a.price < allPricePackageB - b.price) {
          return 1;
        }
        if (allPricePackageA - a.price > allPricePackageB - b.price) {
          return -1;
        }

        return 0;
      });
    },

    setActiveRubricsPackages() {
      // Сбрасываем выбранные пакеты и дальше пересчитываем их активность
      if (this.selectedPackagesId && this.selectedPackagesId.length) {
        this.selectedPackagesId.splice(0);
      }

      // Получаем список выбранных сервисов
      let selectedServices = [];
      for (let rubric in this.selectedServicesForRubrics) {
        selectedServices.push(...this.selectedServicesForRubrics[rubric]);
      }

      // Формируем список с количеством каждой выбранной услуги
      let countSelectedServices = {};
      selectedServices.forEach(el => {
        countSelectedServices[el] = countSelectedServices[el]
          ? countSelectedServices[el] + 1
          : 1;
      });

      // Если есть бесплатные услуги (краткой информации) - уменьшаем количество выбранных услуг с краткой информацией
      if (this.freeRubricsCount) {
        const shortInfoService = this.rubricServices.find(
          el => el.isShortInfoService
        );
        const idShortInfoService = shortInfoService
          ? shortInfoService.id
          : null;

        if (
          idShortInfoService &&
          countSelectedServices[idShortInfoService] &&
          countSelectedServices[idShortInfoService] > 0
        ) {
          countSelectedServices[idShortInfoService] =
            countSelectedServices[idShortInfoService] - this.freeRubricsCount >
            0
              ? countSelectedServices[idShortInfoService] -
                this.freeRubricsCount
              : 0;
        }
      }

      // Перебираем пакеты и смотрим какой можем применить
      this.rubricsPackagesSortDescDiscount.forEach(item => {
        this.setActivePackage(item, countSelectedServices);
      });
    },

    setActivePackage(pack, countSelectedServices) {
      let isActivePackage = true;

      if (pack.services && Object.keys(pack.services).length) {
        // Проверяем, хватает ли нам условий, чтобы применить пакет
        for (let service in pack.services) {
          if (
            !pack.services[service] ||
            !countSelectedServices[service] ||
            pack.services[service] > countSelectedServices[service]
          ) {
            isActivePackage = false;
          }
        }
      } else {
        isActivePackage = false;
      }

      // Если мы можем применить пакет - обновляем данные по используемым услугам и активизируем пакет
      if (isActivePackage) {
        for (let service in pack.services) {
          if (
            pack.services[service] &&
            countSelectedServices[service] &&
            pack.services[service] <= countSelectedServices[service]
          ) {
            countSelectedServices[service] =
              countSelectedServices[service] - pack.services[service];
          }
        }

        this.selectedPackagesId.push(pack.id);

        // Вызываем еще раз и смотрим, можем ли мы применить пакет
        this.setActivePackage(pack, countSelectedServices);
      }
    },

    getPriceForPkg(price, count) {
      return count && count > 1 ? price * count : price;
    },

    getDeclinationWord(count, text_forms) {
      if (count) {
        const n = Math.abs(parseInt(count)) % 100;
        var n1 = n % 10;

        if (n > 10 && n < 20) {
          return text_forms[2];
        }
        if (n1 > 1 && n1 < 5) {
          return text_forms[1];
        }
        if (n1 === 1) {
          return text_forms[0];
        }

        return text_forms[2];
      }

      return null;
    },

    countSelectedPakage(count, price) {
      return this.getDeclinationWord(count, [
        this.$t("event.catalog.modal.rubricator.countSelectedPakage1", {
          count: count,
          price: price
        }),
        this.$t("event.catalog.modal.rubricator.countSelectedPakage3_4", {
          count: count,
          price: price
        }),
        this.$t("event.catalog.modal.rubricator.countSelectedPakage5_20", {
          count: count,
          price: price
        })
      ]);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-catalog-rubrics {
  &__title {
    @include h2();

    display: flex;
    align-items: center;

    margin-bottom: 20px;

    @include respond-down(md) {
      flex-direction: column;
      align-items: flex-start;
      font-size: 16px;
    }

    span {
      font-size: 16px;

      color: #a3a8b3;

      margin-left: 10px;

      @include respond-down(md) {
        margin-left: 0;
        margin-top: 3px;
        font-size: 12px;
      }

      &.pull-right {
        margin-left: auto;

        font-size: 14px;
        font-weight: 500;
        line-height: 1.43;

        color: #6d7179;

        @include respond-down(md) {
          font-size: 12px;
          margin-left: 0;
          margin-top: 12px;
        }
      }
    }
  }

  &__section {
    margin-bottom: 40px;

    @include respond-down(md) {
      margin-bottom: 24px;
    }
  }

  &__for-all {
    padding: 30px 32px;

    margin-bottom: -16px;

    border: 1px solid #cdced0;
    border-radius: 2px;

    box-sizing: border-box;

    @include respond-down(md) {
      padding: 16px 24px 24px 24px;
    }

    &-title {
      @include h3();

      @include respond-down(md) {
        font-size: 14px;
      }
    }

    &-checkbox {
      .event-modal-catalog-example {
        position: relative;
        top: 4px;
      }
    }
  }

  &__rubric {
    border-radius: 2px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border: 1px solid #f1f1f1;
    box-sizing: border-box;

    margin-bottom: 24px;

    @include respond-down(md) {
      margin-bottom: 16px;
    }

    &-header {
      @include h3();

      display: flex;
      align-items: center;
      padding: 30px 32px;

      border-bottom: 1px solid #f1f1f1;

      @include respond-down(md) {
        font-size: 14px;
        padding: 16px 24px;
      }

      &-price {
        flex-shrink: 0;
        padding-left: 30px;

        margin-left: auto;
        margin-right: 30px;

        font-size: 14px;

        color: #a3a8b3;

        &._highlight {
          color: #005197;
        }
      }

      &-delete {
        flex-shrink: 0;
        .svg-icon {
          display: block;
        }
      }
    }

    &-content {
      padding: 0 32px 25px 32px;

      @include respond-down(md) {
        padding: 0 24px 24px 24px;
      }
    }
  }

  &__checkboxes {
    display: flex;
    flex-wrap: wrap;

    &-item {
      width: 340px;

      @include respond-down(lg) {
        width: 320px;
      }

      margin-top: 25px;

      &-desc {
        font-size: 12px;
        color: #6d7179;
        margin-top: 5px;
        margin-bottom: 0;
      }

      &-price {
        font-size: 14px;
        font-weight: bold;

        margin-top: 14px;

        color: #a3a8b3;

        &._highlight {
          color: #005197;
        }
      }

      &-address {
        margin-top: 14px;
      }

      &-oldprice {
        margin-right: 10px;
        text-decoration: line-through;
      }
    }

    &-address {
      margin-bottom: 20px;
    }
  }

  &__packages {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    @include respond-down(lg) {
      justify-content: flex-start;
      margin-right: -20px;
    }
    &-item {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: flex-start;
      align-items: flex-start;
      width: 380px;
      min-height: 180px;

      @include respond-down(lg) {
        width: calc(50% - 20px);
        margin-right: 20px;
      }

      padding: 22px 33px;

      @include respond-down(md) {
        max-width: 100%;
        width: 350px;
        min-height: 140px;
        padding: 16px 24px;
      }

      box-sizing: border-box;

      border: 1px solid #cdced0;
      border-radius: 2px;

      position: relative;

      margin-bottom: 20px;

      &-title {
        @include h3();

        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        @include respond-down(md) {
          font-size: 14px;
        }

        .event-modal-catalog-example {
          margin-top: 3px;
          margin-left: 15px;
        }
      }

      &-text {
        font-size: 12px;
        line-height: 1.33;
        color: #6d7179;
        margin-bottom: 21px;
      }

      &-price {
        font-size: 14px;
        line-height: 1.43;
        color: #000000;
        margin-bottom: 0;
      }

      &-mainprice {
        font-weight: bold;
        color: #a3a8b3;
      }

      &-count {
        color: #005197;
      }

      .svg-icon {
        display: none;

        position: absolute;
        left: 17px;
        top: 27px;

        width: 13px;
        height: 13px;

        color: #0070d2;
      }

      &._active {
        border: 2px solid #0070d2;
        padding-left: 42px;
      }

      &._active &-mainprice {
        color: #005197;
      }

      &._active .svg-icon {
        display: block;
      }
    }
  }
}
</style>
